import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'panel-modal-header',
  templateUrl: 'panel-modal-header.component.html',
  styleUrls: ['panel-modal-header.component.scss'],
})
export class PanelModalHeaderComponent {

  @Input() imageSrc: string;

  @Input() firstTitle: string;

  @Input() secondaryTitle: string;

  @Input() thirdTitle: string;

  @HostBinding('class.bulk-edit')
  @Input() bulkEdit: boolean = false;

  @Input() hasImage: boolean = true;

  @Input() hasPagination: boolean = false;

  @Input() hasDropdown: boolean = false;

  // 'red', 'lightergrey'
  @Input() color: string = 'lightergrey';

  @Input() minimized: boolean = true;

  @Input() previousName: string = '';

  @Input() nextName: string = '';

  @Input() dropdownItems: Array<any>;

  @Output() previousClick: EventEmitter<any> = new EventEmitter();

  @Output() nextClick: EventEmitter<any> = new EventEmitter();

  @Output() selectOption: EventEmitter<any> = new EventEmitter();

  onPrevClick(event: MouseEvent) {
    this.previousClick.emit();
  }

  onNextClick(event: MouseEvent) {
    this.nextClick.emit();
  }

}
